/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconApps/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconApps({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconApps",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconApps.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-H1Qd': alignSelf,'--mt-2-H1Qd': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-H1Qd': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-H1Qd': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-H1Qd': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-H1Qd': opacity,'--w-10-H1Qd': typeof width === 'number' ? `${width}px` : width,'--h-11-H1Qd': typeof height === 'number' ? `${height}px` : height,'--a-7-H1Qd': isAnimated ? animation : "none",'--sd-8-H1Qd': isAnimated ? strokeDashoffset : 0,'--sd-9-H1Qd': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconApps.SvgPath"
  data-view-path={viewPath}
 d="M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z"
 style={{'--f-12-H1Qd': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}